export const calculateCampaignPaymentType = (days: number): string => {
  if (days === 0) return 'Extend';
  else if (days <= 34) return 'Short';
  else if (days <= 178) return 'Medium';
  else return 'Long';
};
